import React, { useState } from 'react';
import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import FormBuilder from 'components/shared/FormBuilder';
import {
  InputErrorFragment,
  EquipmentFragment
} from 'components/shared/fragments';
import { onCompleted, sanitizeData } from 'lib/formHelpers';
import { EquipmentForm } from './form';

const CREATE_EQUIPMENT = gql`
  mutation CreateEquipment($input: CreateEquipmentForOrganizationInput!) {
    result: createEquipmentForOrganization(input: $input) {
      errors {
        ...InputError
      }
      equipment {
        ...Equipment
      }
    }
  }
  ${InputErrorFragment}
  ${EquipmentFragment}
`;

const UPDATE_EQUIPMENT = gql`
  mutation UpdateEquipment($input: UpdateEquipmentForOrganizationInput!) {
    result: updateEquipmentForOrganization(input: $input) {
      errors {
        ...InputError
      }
      equipment {
        ...Equipment
      }
    }
  }
  ${EquipmentFragment}
  ${InputErrorFragment}
`;

const initialValues = {
  name: '',
  aliases: [],
  establishesRoutes: [],
  sources: []
};

const CreateOrUpdateEquipment = ({
  equipment,
  organizationId,
  onComplete
}: any) => {
  const [errors, setErrors] = useState({});
  const [createOrUpdateEquipment, { loading }] = useMutation(
    equipment ? UPDATE_EQUIPMENT : CREATE_EQUIPMENT,
    {
      onCompleted: (response: any) =>
        onCompleted({ response, setErrors, onComplete })
    }
  );

  let formData = sanitizeData(equipment, ['lastPublishedAt']) || initialValues;

  // Normalize sources to be a list of id values
  // @ts-expect-error TS(2339): Property 'sources' does not exist on type 'object'... Remove this comment to see the full error message
  formData.sources = formData.sources.map((source: any) => source.id);

  return (
    <FormBuilder
      key={equipment?.id ?? -1}
      initialValues={formData}
      form={EquipmentForm(organizationId)}
      errors={errors}
      isLoading={loading}
      onSubmit={(input: any) => {
        setErrors({});
        createOrUpdateEquipment({
          variables: { input: { ...input, organizationId } }
        });
      }}
    />
  );
};

export default CreateOrUpdateEquipment;
